// extracted by mini-css-extract-plugin
export default {"sidebar-thumb-width":"92","sidebarThumbWidth":"92","sidebar-thumb-height":"92","sidebarThumbHeight":"92","root":"_12G69","grid-item":"xxZzZ","gridItem":"xxZzZ"};